import React, {Component, Fragment} from 'react';
import {Button, CardTitle} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../../../constants/configs';
import ModalManager from '../../../../components/modal/ModalManager';
import TagManageForm from "../../../../containers/TagManageForm";
import {i18nizeDate} from '../../../../helpers/Utils';
import {join, keyBy, mapValues, omit} from 'lodash'
import Rbac from '../../../../components/Rbac';
import Api from "../../../../services/Api";
import ReactTable from 'react-table';


class TagsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      loading: false,
      pages: -1,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke('GET', '/v2/admin-ui/tags', null, {
        params: {
          offset,
          limit: state.pageSize,
          ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
        }
      });
      this.setState({
        tags: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onPressDelete = (id, name) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete {{name}} category ?', {
        name
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            this.deleteTag(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  onPressCreate = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Add New Category'),
      body: <TagManageForm afterSubmit={async () => {await this.fetchData(this.table.state);}}/>
    });
  };

  onPressEdit = tag => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit {{name}} category', {name: tag.name}),
      body: <TagManageForm tag={tag} afterSubmit={async () => {await this.fetchData(this.table.state);}}/>
    });
  };

  deleteTag = async id => {
    try {
      await Api.invoke('DELETE', `/v2/admin-ui/tags/${id}`);
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log("error: ", e);
    }
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      width: 200,
      className: 'font-weight-semibold'
    },
    {
      Header: t('Tokens'),
      accessor: 'tokens',
      Cell: props => {
        if (props.value) {
          return <span>{join(props.value, ', ')}</span>;
        }
        return null;
      }
    },
    {
      Header: t('Status'),
      accessor: 'enabled',
      Cell: props => {
        return (
          <span className={`font-weight-semibold ${props.value ? 'text-success' : 'text-danger'}`}>
            {props.value ? t('Enabled') : t('Disabled')}
          </span>
        );
      },
      width: 150,
    },
    {
      Header: t('Register Date'),
      accessor: 'createdAt',
      width: 150,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      width: 150,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Actions'),
      accessor: 'id',
      Cell: props => <div className='d-flex flex-row align-items-center'>
        <Rbac permission="update_tag">
          <i
            className="simple-icon-pencil edit-icon mr-4 cursor-pointer"
            onClick={() => {this.onPressEdit(props.original);}}
          />
        </Rbac>
        <Rbac permission="delete_tag">
          <i
            className="simple-icon-trash delete-icon cursor-pointer"
            onClick={async () => {await this.onPressDelete(props.value, props.original.name);}}
          />
        </Rbac>
      </div>,
      width: 100,
      show: Rbac.hasPermission('update_tag') || Rbac.hasPermission('delete_tag'),
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center">
          <Rbac permission='create_tag'>
            <Button onClick={this.onPressCreate}>
              <i className="simple-icon-plus add-reply-icon"/>
              <span className="mx-1">{t('Add New Category')}</span>
            </Button>
          </Rbac>
        </CardTitle>
        <ReactTable
          manual
          ref={el => {this.table = el;}}
          className="-highlight"
          data={this.state.tags}
          loading={this.state.loading}
          sortable={false}
          resizable={true}
          onFetchData={this.fetchData}
          columns={this.getColumns(t)}
          defaultPageSize={25}
          style={{
            width: '100%',
          }}
          {...reactTableText}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(TagsList);
